"use client";

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { UserRole } from "@/services/contracts/types";

type AuthStore = {
  hasHydrated: boolean;
  isAuthenticated: boolean;
  token: string | null;
  username: string | null;
  role: UserRole;
  status: "approved" | "pending" | "rejected";
  signIn: (payload: {
    token: string;
    username: string;
    role: UserRole;
    status: "approved" | "pending" | "rejected";
  }) => void;
  signOut: () => void;
  setHasHydrated: (value: boolean) => void;
};

const initialState = {
  hasHydrated: false,
  isAuthenticated: false,
  token: null,
  username: null,
  role: "user" as UserRole,
  status: "approved" as const
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      ...initialState,
      setHasHydrated: (value) => set({ hasHydrated: value }),
      signIn: ({ token, username, role, status }) =>
        set({ isAuthenticated: true, token, username, role, status }),
      signOut: () => set(initialState)
    }),
    {
      name: "stella-ui-auth",
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      }
    }
  )
);
